import { EngineReportDetails, EngineReportDetailsVm } from '@navstation-portal/reporting/data-model/engine-report';
import { VesselSpec } from '@navstation-portal/vessels/data-model/vessel';
import { buildCoolingWaterSystemVm } from './sections/cooling-water-system-vm';
import { buildCurrentSlipVm } from './sections/current-slip-vm';
import { buildFuelOilPropertiesConsumptionVm } from './sections/fuel-oil-properties-consumption-vm';
import { buildHydraulicOilPressureVm } from './sections/hydraulic-oil-pressure-vm';
import { buildLubeOilSystemVm } from './sections/lube-oil-system-vm';
import { buildPerformanceParametersVm } from './sections/performance-parameters-vm';
import { buildScavengeExhaustVm } from './sections/scavenge-exhaust-vm';
import { buildSwashPlatePositionVm } from './sections/swash-plate-position-vm';

export function buildEngineReportDetailsVm(
  details: EngineReportDetails | undefined,
  vesselSpec: VesselSpec | undefined,
  reportNumber?: number
): EngineReportDetailsVm {
  const performanceParametersVm = buildPerformanceParametersVm(details, vesselSpec, reportNumber);

  return {
    ...details,
    ...performanceParametersVm,
    ...buildFuelOilPropertiesConsumptionVm(details, performanceParametersVm.reportPeriod),
    ...buildScavengeExhaustVm(details),
    ...buildCoolingWaterSystemVm(details),
    ...buildLubeOilSystemVm(details, vesselSpec),
    ...buildHydraulicOilPressureVm(details),
    ...buildCurrentSlipVm(details),
    ...buildSwashPlatePositionVm(details),
  };
}
